import { StructureType } from '../types/types';
import { isJson } from './dataTypes';
import dayjs from 'dayjs';

export const isWeightModelField = (structure: StructureType): boolean => {
 if (structure?.Type !== 'model') return false;
 return structure.InnerStructure?.some((s) => s.Name === 'Weight') ?? false;
};

export const getModelInfo = (filter: string): { id: string; name: string } => {
 const fallback = { id: '', name: '' };
 if (!filter || !isJson(filter)) return fallback;

 try {
  const parsed = JSON.parse(filter) as { fields?: string };
  const fieldsRaw = typeof parsed?.fields === 'string' ? parsed.fields : '';
  const parts = fieldsRaw.split(',');
  return {
   id: parts[0] ?? '',
   name: parts[1] ?? '',
  };
 } catch {
  return fallback;
 }
};

export function displayValueByType(value: any, structure: StructureType) {
 try {
  return displayValueByTypeInner(value, structure);
 } catch {
  return typeof value === 'object' && value !== null
   ? JSON.stringify(value)
   : (value as string | number);
 }
}

function displayValueByTypeInner(value: any, structure: StructureType) {
 let val = value;

 if (val === null || val === undefined) {
  val = '-';
 } else if (structure?.Type === 'model') {
  if (isWeightModelField(structure)) {
   if (typeof val === 'object' && !Array.isArray(val)) {
    val = (val as Record<string, unknown>).Weight ?? '-';
   }
  } else if (typeof val === 'object' && !Array.isArray(val)) {
   const { name: nameVar } = getModelInfo(
    structure.ForeignKeyDefaultFilter || '',
   );
   const displayed = nameVar
    ? (val as Record<string, unknown>)[nameVar]
    : undefined;
   val =
    displayed !== null && displayed !== undefined
     ? String(displayed)
     : JSON.stringify(val);
  } else {
   val = String(val);
  }
 } else if (structure?.Type === 'array') {
  const { name: nameVar } = getModelInfo(
   structure?.ForeignKeyDefaultFilter || '',
  );
  val = Array.isArray(val)
   ? val.map((item: any) => item[nameVar]).join(', ')
   : JSON.stringify(val);
 } else if (typeof val === 'object') {
  val = JSON.stringify(val);
 } else if (structure?.Type === 'boolean') {
  val = val ? 'Taip' : 'Ne';
 } else if (structure?.Type === 'enum') {
  val = structure?.EnumValues[value];
 } else if (['int32', 'int16', 'double'].includes(structure?.Type)) {
  val = value;
 } else if (structure?.Type === 'datetime') {
  val = value ? dayjs(value).format('DD.MM.YYYY HH:mm') : '-';
 } else if (structure?.Type === 'string') {
  val = value;
 } else {
  val = value;
 }
 if (val !== null && typeof val === 'object') {
  return JSON.stringify(val);
 }
 return val as string | number;
}

